import { Outlet, createFileRoute } from '@tanstack/react-router'

import { AuthLayout } from '@/layouts/AuthLayout/AuthLayout'

export const Route = createFileRoute('/_authRoutes')({
  component: AuthLayoutComponent,
})

function AuthLayoutComponent() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  )
}
